import { Host, h, } from "@stencil/core";
import state from "../store";
import { commonClassesNames } from "../../common/classesNames";
export class GxgComboBoxItem {
    constructor() {
        this.icon = undefined;
        this.value = undefined;
        this.index = undefined;
        this.disabled = false;
        this.selected = false;
        this.exactMatch = false;
        this.hidden = false;
        this.iconColor = undefined;
    }
    el;
    /**
     * This event is triggered when the user clicks on an item. event.detail contains the item index, item value, and item icon.
     */
    itemSelected;
    /**
     * This event is fired when the item has loaded
     */
    itemDidLoad;
    /**
     * This event is for internal use. This event is triggered when the user presses keyboard "arrow up" on the first item. This event is caputred on "combo" component
     * and then focus is set on "search" input.
     */
    keyDownPressed;
    componentWillLoad() {
        this.setup();
        this.disabled ? (this.iconColor = "ondisabled") : (this.iconColor = "auto");
    }
    componentDidLoad() {
        this.itemDidLoad.emit({
            el: this.el,
            index: this.index,
            value: this.value,
            icon: this.icon,
        });
    }
    /*********************************
    WATCH
    *********************************/
    setup = () => {
        if (!this.value) {
            this.value = this.el.innerHTML;
        }
    };
    clickHandler = () => {
        this.itemSelected.emit({
            el: this.el,
            index: this.index,
            value: this.value,
            icon: this.icon,
        });
    };
    iconColorHandler() {
        if (this.disabled) {
            return "disabled";
        }
        else if (this.selected) {
            return "primary-enabled";
        }
        else {
            return "auto";
        }
    }
    render() {
        return (h(Host, { onClick: this.clickHandler, class: {
                large: state.large,
                "no-icon": !this.icon,
                [commonClassesNames["DISABLED_CLASS"]]: this.disabled,
            } }, h("div", { class: { container: true, "form-element": true } }, this.icon ? (h("gxg-icon", { color: this.iconColorHandler(), size: state.large ? "regular" : "small", type: this.icon })) : null, h("div", { class: "description" }, h("slot", null)))));
    }
    static get is() { return "gxg-combo-box-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["combo-box-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["combo-box-item.css"]
        };
    }
    static get properties() {
        return {
            "icon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Any icon that belongs to Gemini icon library: https://gx-gemini.netlify.app/?path=/story/icons"
                },
                "attribute": "icon",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "value": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "ComboBoxItemValue",
                    "resolved": "any",
                    "references": {
                        "ComboBoxItemValue": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/combo-box-item/combo-box-item.tsx",
                            "id": "src/components/combo-box-item/combo-box-item.tsx::ComboBoxItemValue"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The item value. If value is not provided, an automatic value will be generated with the innerText."
                },
                "attribute": "value",
                "reflect": false
            },
            "index": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "(This prop is for internal use)."
                },
                "attribute": "index",
                "reflect": true
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes this combo-item disabled and not interactive."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "selected": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes this combo-item selected."
                },
                "attribute": "selected",
                "reflect": true,
                "defaultValue": "false"
            },
            "exactMatch": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "True if the text typed on the combo box input is equal to this combo box item text"
                },
                "attribute": "exact-match",
                "reflect": true,
                "defaultValue": "false"
            },
            "hidden": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property hides the combo box item"
                },
                "attribute": "hidden",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "iconColor": {}
        };
    }
    static get events() {
        return [{
                "method": "itemSelected",
                "name": "itemSelected",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This event is triggered when the user clicks on an item. event.detail contains the item index, item value, and item icon."
                },
                "complexType": {
                    "original": "ItemInformation",
                    "resolved": "{ el: HTMLGxgComboBoxItemElement; index: number; value: any; icon?: string; }",
                    "references": {
                        "ItemInformation": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/combo-box-item/combo-box-item.tsx",
                            "id": "src/components/combo-box-item/combo-box-item.tsx::ItemInformation"
                        }
                    }
                }
            }, {
                "method": "itemDidLoad",
                "name": "itemDidLoad",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This event is fired when the item has loaded"
                },
                "complexType": {
                    "original": "ItemInformation",
                    "resolved": "{ el: HTMLGxgComboBoxItemElement; index: number; value: any; icon?: string; }",
                    "references": {
                        "ItemInformation": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/combo-box-item/combo-box-item.tsx",
                            "id": "src/components/combo-box-item/combo-box-item.tsx::ItemInformation"
                        }
                    }
                }
            }, {
                "method": "keyDownPressed",
                "name": "keyDownPressed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This event is for internal use. This event is triggered when the user presses keyboard \"arrow up\" on the first item. This event is caputred on \"combo\" component\nand then focus is set on \"search\" input."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=combo-box-item.js.map
